import { setDefaultOptions, enUS } from '@bamboohr/utils/lib/datetime';
import { i18n } from '@bamboohr/utils/lib/locale';

export const configureDateFnsForEnglish = () => {
	if (i18n.language === 'en-US') {
		setDefaultOptions({ locale: enUS });
	}
};
